export default __webpack_public_path__ + "static/media/TTD3.ea0bb777.png";